<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8,0C3.58,0,0,3.58,0,8C0,12.42,3.58,16,8,16C12.42,16,16,12.42,16,8C16,3.58,12.42,0,8,0C8,0,8,0,8,0ZM13.17,5C13.17,5,10.73,5,10.73,5C10.52,3.89,10.22,2.97,9.82,2.31C11.25,2.77,12.43,3.74,13.17,5C13.17,5,13.17,5,13.17,5ZM10,8C10,8.73,9.95,9.39,9.88,10C9.88,10,6.12,10,6.12,10C6.05,9.39,6,8.73,6,8C6,7.27,6.05,6.61,6.12,6C6.12,6,9.88,6,9.88,6C9.95,6.61,10,7.27,10,8C10,8,10,8,10,8ZM8,2C8.67,2,9.36,3.1,9.73,5C9.73,5,6.27,5,6.27,5C6.64,3.1,7.33,2,8,2C8,2,8,2,8,2ZM6.18,2.31C5.78,2.97,5.47,3.89,5.27,5C5.27,5,2.83,5,2.83,5C3.57,3.74,4.75,2.77,6.18,2.31C6.18,2.31,6.18,2.31,6.18,2.31ZM2,8C2,7.3,2.13,6.63,2.35,6C2.35,6,5.11,6,5.11,6C5.04,6.62,5,7.28,5,8C5,8.72,5.04,9.38,5.11,10C5.11,10,2.35,10,2.35,10C2.13,9.37,2,8.7,2,8C2,8,2,8,2,8ZM2.83,11C2.83,11,5.27,11,5.27,11C5.48,12.11,5.78,13.03,6.18,13.69C4.75,13.23,3.57,12.26,2.83,11C2.83,11,2.83,11,2.83,11ZM8,14C7.33,14,6.64,12.9,6.27,11C6.27,11,9.73,11,9.73,11C9.36,12.9,8.67,14,8,14C8,14,8,14,8,14ZM9.82,13.69C10.22,13.03,10.52,12.11,10.73,11C10.73,11,13.17,11,13.17,11C12.43,12.26,11.25,13.23,9.82,13.69C9.82,13.69,9.82,13.69,9.82,13.69ZM13.65,10C13.65,10,10.89,10,10.89,10C10.96,9.38,11,8.72,11,8C11,7.28,10.96,6.62,10.89,6C10.89,6,13.65,6,13.65,6C13.87,6.63,14,7.3,14,8C14,8.7,13.87,9.37,13.65,10C13.65,10,13.65,10,13.65,10Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'GlobeNetwork',
} as DefineComponent
</script>
